import { useState, useEffect, useContext } from 'react';

import { List, Paper, InputBase, useTheme } from '@mui/material';

import { Search as SearchIcon } from '@mui/icons-material';

import ContactListItemCustom from '../ContactsListItemCustom';
import ContactsSkeleton from '../ContactsListSkeleton';
import ContactListItemAdd from '../ContactsListItemAdd';
import ContactModal from '../ContactModal';

import api from '../../services/api';
import { getStyled } from './styles';
import { TicketsContext } from '../../context/Tickets/TicketsContext';
import { AuthContext } from '../../context/Auth/AuthContext';

const ContactsListCustom = ({ style, contact }) => {
  const theme = useTheme();
  const classes = getStyled(theme);
  const [contactsData, setContactsData] = useState([]);
  const { searchContact, setSearchContact } = useContext(TicketsContext);
  const { isAuth } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(true);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [newContact, setNewContact] = useState({});
  const [contactName, setContactName] = useState('');

  useEffect(() => {
    if (!isAuth) return;
    const fetchContacts = async () => {
      setIsLoading(true);

      try {
        const isNumber = !isNaN(Number(searchContact));
        const body = isNumber
          ? { number: searchContact }
          : { name: searchContact };
        const { data } = await api.post('/contacts/find', body);
        setContactsData(data.slice(0, 400));
      } catch (err) {
        console.error('Erro ao buscar contatos:', err);
      }
      setIsLoading(false);
    };

    fetchContacts();

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [searchContact, isAuth]);

  const handleCloseContactModal = () => {
    setSearchContact('');
    setContactModalOpen(false);
  };

  function handleInputChange(e) {
    const inputValue = e.target.value.trimStart();

    setSearchContact(inputValue);
    setContactName(inputValue);

    if (/^\d+$/.test(inputValue)) {
      setNewContact({ number: inputValue });
    } else {
      setNewContact({ name: inputValue });
    }
  }

  return (
    <Paper sx={{ ...classes.contactsListWrapper, ...style }}>
      <div style={classes.serachInputWrapper}>
        <SearchIcon sx={classes.searchIcon} />
        <InputBase
          sx={classes.searchInput}
          size='small'
          variant='outlined'
          label='Buscar contato'
          value={searchContact}
          onChange={(e) => handleInputChange(e)}
          placeholder='Digite o nome ou número do contato'
        />
      </div>
      <Paper square elevation={0} sx={classes.contactsList}>
        <List sx={{ paddingTop: 0 }}>
          {
            <>
              <ContactListItemAdd
                contact={contact}
                setContactModalOpen={setContactModalOpen}
                contactName={contactName}
              />
              {contactsData.map((contact) => (
                <ContactListItemCustom contact={contact} key={contact.id} />
              ))}
            </>
          }
          {isLoading && <ContactsSkeleton />}
        </List>
      </Paper>
      {contactModalOpen && (
        <ContactModal
          open={contactModalOpen}
          initialValues={newContact}
          onClose={handleCloseContactModal}
        ></ContactModal>
      )}
    </Paper>
  );
};

export default ContactsListCustom;
